<script setup>
/**
 * Card for displaying a permission on the OrganizationRoleEditPage.
 */

import ToggleSwitch from '@/components/Forms/ToggleSwitch.vue'

defineProps({
	perm: { type: Object, required: true, default: null },//Permission object (single column in organization_roles table (ex admin_permissions)
	disabled: { type: Boolean, default: false },//False if disabled
})

</script>

<template>
	<div v-if="perm" class="perm-wrap">
		<div class="perm-title">{{ perm.title }}</div>
		<div class="text-sm">{{ perm.description }}</div>
		<div v-for="item in perm" :key="item.title" >
			<div v-if="typeof item === 'object'" class="perm-inner-wrap mb-2" >
				<div>
					<div class="font-semibold mb-1">{{ item.title }}</div>
					<div class="text-grayscale-body">{{ item.description }}</div>
				</div>
				<div>
					<ToggleSwitch v-model="item.enabled" :disabled="disabled || !item.editable" screen_reader_text="Toggle Setting" size="small" />
				</div>
			</div>
		</div>

	</div>
</template>

<style scoped>
.perm-wrap
{
	@apply border border-t-[.25rem] border-primary-darker w-100 mb-5 text-sm border border-primary rounded-lg p-3 hover:border-primary-subtle-hover;
}

.perm-title
{
	@apply mb-2 font-semibold text-base;
}

.perm-inner-wrap
{
	@apply flex flex-row justify-between items-start;
}
</style>